/**
 * Tool input normalization utilities.
 * Consolidates all tool input transformation logic in one place.
 */

import type { TodoTask } from "@/components/execution/AgentTodoList";
import { ensureTaskIds } from "../utils/todo-utils";

/**
 * Normalize tool input based on tool name and input structure.
 * Handles special cases like TodoWrite task ID assignment.
 */
export function normalizeToolInput(
	toolName: string,
	toolInput: Record<string, unknown>
): Record<string, unknown> {
	// TodoWrite: ensure all tasks have stable IDs
	if (toolName === "TodoWrite" && toolInput.todos && Array.isArray(toolInput.todos)) {
		return {
			...toolInput,
			todos: ensureTaskIds(toolInput.todos as TodoTask[]),
		};
	}

	// Add other tool-specific normalizations here as needed

	return toolInput;
}

/**
 * Safe JSON parse with fallback.
 */
export function parseToolInput(
	content: string,
	fallback: Record<string, unknown> = {}
): Record<string, unknown> {
	try {
		return JSON.parse(content) as Record<string, unknown>;
	} catch {
		return { raw: content, ...fallback };
	}
}
